// extracted by mini-css-extract-plugin
export default {"co-branding-banner":"BDGMmw","coBrandingBanner":"BDGMmw","top":"REwZHQ","logo-wrapper":"f1yxna","logoWrapper":"f1yxna","rtl":"zDFi6H"};